const homeAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP */

      let mm = gsap.matchMedia();

      //H1 BANNER
      let split = SplitText.create(".header h1", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
      });

      //WELCOME TEXT
      split = SplitText.create(".content-text", { type: "lines" });

      gsap.from(split.lines, {
        //rotationX: 50,
        //transformOrigin: "50% 50% -160px",
        scrollTrigger: {
          trigger: ".welcome-content",
          start: "top+=100 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
      });

      //BLEU SECTION TITLE
      split = SplitText.create(".blue-title", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".blue-content",
          start: "top+=100 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

      //COMMITMENT SECTION
      split = SplitText.create(".ellipsis h2", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".commitment",
          start: "top+=100 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

      let commitments = document.querySelectorAll(".commitments-container div");
      gsap.from(commitments, {
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".commitment",
          start: "20% 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

      //CLIENT SECTION


      split = SplitText.create(".clients h2", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".clients",
          start: "top+=100 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

      mm.add("(min-width: 900px)", () => {
      gsap.from('.client-1', {
        x: -100,
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".client-1",
          start: "60% 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

      gsap.from('.client-2', {
        x: 100,
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".client-2",
          start: "60% 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

    });
    

      /* PARTNERS SWIPER */
      const swiper = new Swiper(".partnersSwiper", {
        spaceBetween: 0,
        speed: 5000,
        direction: "horizontal",
        autoplay: { delay: 0 },
        loop: true,
        slidesPerView: 2,
        freeMode: true,
        breakpoints: {
          640: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 5,
          },
          1024: {
            slidesPerView: 5,
          },
        },
      });
    });
  },
};

export default homeAnim;
